export default "__VITE_ASSET__915527fb__"